<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-back-button v-if="shouldShowBack" default-href="/home"></ion-back-button>
                    <ion-button @click="openMenu()">
                        <ion-icon :icon="menu"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>{{pageTitle}}</ion-title>
                <ion-buttons slot="end">
                    <select v-model="$i18n.locale">
                        <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
                    </select>
                </ion-buttons>
                <img src="../../resources/logosmall.png" class="logoimage" slot="end" />
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <slot></slot>
        </ion-content>
    </ion-page>
</template>
<script>
import { IonPage, IonHeader, IonContent, IonTitle, IonToolbar, menuController, IonButtons, IonIcon, IonBackButton, IonButton } from '@ionic/vue';
import { menu } from "ionicons/icons";
export default {
    components:{
        IonPage,IonHeader,IonContent,IonTitle,IonToolbar, IonButtons, IonIcon, IonBackButton, IonButton
    },
    props: {
        pageTitle: String,
        // Allow individual pages to override back button visibility
        showBack: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
        menu,
        langs: ['sv', 'en']
        };
    },
    computed: {
        shouldShowBack() {
            if (!this.showBack) return false;
            const rootPaths = ['/home', '/login', '/register', '/documentation'];
            return !rootPaths.includes(this.$route.path);
        }
    },
    methods: {
        openMenu() {
            menuController.open("app-menu");
        },
    },
}
</script>